<template>
  <div>
    <new-filters-menu v-if="!isMobile" class="mb-4" show-outdated-warning :filters="['industrias', 'industria-mecanica']" />
    <campaigns-table
      v-if="isFranchisee"
      class="mb-3"
      :franchisee="true"
      :industry="true"
      :finished="true"
      :units="units"
      :units-configuration="unitsConfiguration"
      :products="products"
      :itemsFilter="filterListFranchisee"
    >
      <template v-slot:title> Histórico da rede </template>
    </campaigns-table>

    <campaigns-table class="mb-3" :units="units" :industry="true" :finished="true" :products="products" :itemsFilter="filterListFranchisee">
      <template v-slot:title> Histórico </template>
    </campaigns-table>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import { getStatusLabel } from '@/config/helpers.js'

export default {
  components: {
    CampaignsTable: () => import('@/modules/campanhas/gestao-ofertas-v2/views/components/CampaignsTable'),
    NewFiltersMenu: () => import('@/components/filters-menu/NewFiltersMenu.vue'),
  },
  data() {
    return {
      filterListFranchisee: [
        { label: getStatusLabel('FINISHED').text, value: 'finished', color: getStatusLabel('FINISHED').color, active: true },
        { label: getStatusLabel('INDUSTRY_REJECTED').text, value: 'industry_rejected', color: getStatusLabel('INDUSTRY_REJECTED').color, active: true },
        { label: getStatusLabel('EXPIRED').text, value: 'expired', color: getStatusLabel('EXPIRED').color, active: true },
      ],
    }
  },
  computed: {
    ...mapState({
      units: (state) => state.filters.units || [],
      unitsConfiguration: (state) => state.filters.unitsConfiguration,
      products: (state) => state.filters.products,
    }),
    isFranchise() {
      // rede
      if (!this.$getLoggedUser().is_franchise) return false
      return this.$getLoggedUser().is_franchise
    },
    isFranchisee() {
      // franquia
      if (!this.$getLoggedUser().is_franchisee) return false
      return this.$getLoggedUser().is_franchisee
    },
  },
}
</script>
